export const SEARCH_HIST_KEY = 'SEARCH_HISTORY';
